import Default from './Default.js'
import FullPage from './FullPage.js'
import Dots from './Dots.js'

export default {
    default: Default,
    fullPage: FullPage,
    dots: Dots,
}
